/* eslint-disable react/prop-types */ // TODO: add props
import { IndicatorCell, INDICATOR_TYPES } from '../../../../../components';
import { RowExpansionArrow } from '../../../components/Icons';
import EquationSolution from 'edrolo/components/exams/solutions/EquationSolution';
import {
  correctableQuestionPropTypes,
  CorrectableQuestionReview,
} from './CorrectableQuestionReview';
import {
  name,
  selfReflection,
} from '../../../components/TableColumns/TableColumns';
import { parseEquationsFromResponse } from 'edrolo/domains/exams/components/Question/components/ComplexSolutionQuestion/utils/equationParser';
import style from './styles.scss';

const ComplexSolutionQuestionReview = ({
  question,
  solution,
  responses,
  highlightProfileId,
  studentCourseProgUrl,
  classStudentProfiles,
}) => {
  const expander = {
    id: 'expander',
    Header: '',
    style: { width: '3%' },
    Cell: ({ row }) =>
      row.original.get('answer') ? (
        <div
          className={style.expanderWidgetContainer}
          {...row.getToggleRowExpandedProps()}
        >
          {row.isExpanded ? (
            <RowExpansionArrow expanded />
          ) : (
            <RowExpansionArrow />
          )}
        </div>
      ) : null,
  };

  const studentResponseColumn = {
    id: 'studentResponse',
    Header: 'Student Response',
    accessor: (row) => {
      return {
        response: row.get('response'),
        answer: row.get('answer'),
      };
    },
    Cell: ({ cell, row }) => {
      const { response, answer } = cell.value;

      if (!answer) {
        return (
          <IndicatorCell
            value={'Not answered'}
            indicatorType={INDICATOR_TYPES.NEUTRAL}
          />
        );
      }

      // Protect against malformed responses when parsing equations
      let equations = [];
      try {
        equations = parseEquationsFromResponse(response);
      } catch (e) {
        // Swallow parse errors and fall back to raw answer
        equations = [];
      }

      return (
        <div {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <div className={style.responseWrapper}>
              {equations && equations.length > 0 ? (
                <EquationSolution equations={equations} />
              ) : (
                <span>{answer}</span>
              )}
            </div>
          ) : (
            <div className={style.responseWrapper}>
              <span>View student response</span>
            </div>
          )}
        </div>
      );
    },
    sortType: (rowA, rowB) => {
      const hasAnswerA = !!rowA.original.get('answer');
      const hasAnswerB = !!rowB.original.get('answer');
      if (hasAnswerA === hasAnswerB) {
        return 0;
      }
      // Answered rows first
      return hasAnswerA ? -1 : 1;
    },
  };

  const studentSelfMarks = {
    id: 'studentSelfMarks',
    Header: 'Student Mark',
    style: { width: '15%' },
    accessor: (row) => {
      const questionMark = Number(question.get('marks')) || 1;
      const studentMarks = Number(
        row.getIn(['response', 'text_marks_from_student'])
      );

      if (!isNaN(studentMarks)) {
        return `${studentMarks.toFixed(0)}/${questionMark.toFixed(0)}`;
      }

      return 'N/A';
    },
    sortType: (rowA, rowB) => {
      const a = Number(rowA.original.getIn(['response', 'marks_final'])) || 0;
      const b = Number(rowB.original.getIn(['response', 'marks_final'])) || 0;
      if (a === b) {
        return 0;
      }
      return a > b ? 1 : -1;
      // or simply: return a - b;
    },
  };

  return (
    <CorrectableQuestionReview
      question={question}
      solution={solution}
      responses={responses}
      highlightProfileId={highlightProfileId}
      studentCourseProgUrl={studentCourseProgUrl}
      classStudentProfiles={classStudentProfiles}
      nameColumn={{
        ...name(studentCourseProgUrl),
        style: { width: '20%' },
      }}
      studentSelfMarks={studentSelfMarks}
      studentResponseColumnSpec={{
        ...studentResponseColumn,
        style: { width: '35%' },
      }}
      answeredCorrectlyColumn={{
        id: 'answeredCorrectly',
        style: { width: '0%' },
      }}
      selfReflectionColumn={{ ...selfReflection, style: { width: '12%' } }}
      expanderColumn={expander}
    />
  );
};

export default ComplexSolutionQuestionReview;

ComplexSolutionQuestionReview.propTypes = correctableQuestionPropTypes;
